import {
	DESKTOP_APPS,
	MAP_ADDON_TO_LATEST_VERSION,
	SUBSCRIPTION_PLAN
} from '../../config';
import CenteredContent from 'components/CenteredContent/CenteredContent';
import Description from '../../components/Description';
import { withStyles } from '@material-ui/core/styles';
import { Button, Link } from '@material-ui/core';
import Header from '../../components/Header';
import { bindActionCreators } from 'redux';
import { writeUserSettings } from 'redux/modules/session';
import { writeCompanySettings } from 'redux/modules/companies';
import Grid from '@material-ui/core/Grid';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import i18n from 'i18n/i18n';
import _ from 'lodash';
import Typography from '@material-ui/core/Typography';
import { getSubscriptionsAndAddons, convertPlanIdIntoSubscription } from '../../utils/subscription';
import { trackAndDownload, getAddonDataForDownload } from '../../utils/downloads';
import { getTrackingOptions } from 'lib/Segment/helpers';

const localize = i18n.loc.localize;

const styles = (theme) => ({
	windowsInfo: {
		fontStyle: 'italic',
		fontSize: '14px',
		lineHeight: '15px',
		display: 'block',
		paddingTop: '10px'
	},
	bold: { fontWeight: 'bold' },
	link: { marginLeft: '53px' },
	button: { minWidth: '380px' },
	product: { 
		marginBottom: 20
	},
	buttonOwned: {
	},
	buttonNotOwned: {
		borderColor: theme.palette.colors.alpha,
		'&:hover': {
			borderColor: '#2888C3'
		}
	},
	ownedProducts: {
		marginBottom: 20,
		'& + div': {
			borderTop: '1px solid #ebebeb',
			paddingTop: 20
		}
	},
	ownedProductsTitle: {
		color: '#000',
		marginBottom: 20
	}
});

@withStyles(styles)
class XCPlus extends Component {

		onDownloadClick = (downloadUrl, storageKey, trackingKey) => {
			trackAndDownload(this.props, downloadUrl, storageKey, trackingKey, getTrackingOptions(this.props.company));
		}

		getTempAddonObject(plan) {
			return {
				id: `${MAP_ADDON_TO_LATEST_VERSION[plan]}-per-eur`,
				active: true,
				users: [this.props.user.userId]
			};
		}

		deleteSavedPendingPerpetualPlan(plan) {
			const pendingPerpetualPlans = _.get(this.props.company, 'settings.pendingPerpetualPlans', {});
			delete pendingPerpetualPlans[plan];
			this.props.writeCompanySettings({ pendingPerpetualPlans });			
		}

		renderProducts() {
			const { company } = this.props;

			let { subscription, perpetualAddons } = getSubscriptionsAndAddons(company);

			const pendingPerpetualPlans = _.get(this.props.company, 'settings.pendingPerpetualPlans', {});
			if (!_.isEmpty(pendingPerpetualPlans)) {
				perpetualAddons = perpetualAddons || [];

				const perpetualsPlans = [
					{
						cbPlanId: 'photol-per-eur',
						plan: SUBSCRIPTION_PLAN.PHOTO_PERPETUAL
					},
					{
						cbPlanId: 'webl-per-eur',
						plan: SUBSCRIPTION_PLAN.WEB_PERPETUAL
					},
					{
						cbPlanId: 'designerl-per-eur',
						plan: SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL
					}
				];

				perpetualsPlans.forEach(item => {
					if (pendingPerpetualPlans[item.cbPlanId]) {
						const pendingPlanData = this.getTempAddonObject(item.plan);
						if (!perpetualAddons.find(item => item.id === pendingPlanData.id)) {
							perpetualAddons.push(pendingPlanData);
						} else {
							this.deleteSavedPendingPerpetualPlan(item.cbPlanId);
						}
					}
				});
			}

			const hasPerpetualPlan = !_.isEmpty(perpetualAddons) && !this.props.company.hasUnlimitedTeamSubscription;
			const hasSubscription = !_.isEmpty(subscription);

			const plansToRender = [];

			const addSubscriptionsToRenderQueue = () => {

				if (!_.isEmpty(subscription)) {
					const { plan } = convertPlanIdIntoSubscription(subscription.planId);
					if (plan === SUBSCRIPTION_PLAN.DESIGNER) {
						plansToRender.push({...DESKTOP_APPS.DESIGNER, owned: true, primary: true});
					} else {
						plansToRender.push(
							{...DESKTOP_APPS.DESIGNER, owned: true, primary: plan === SUBSCRIPTION_PLAN.DESIGNER},
							{...DESKTOP_APPS.WEB, owned: true, primary: plan === SUBSCRIPTION_PLAN.WEB},
							{...DESKTOP_APPS.PHOTO, owned: true, primary: plan === SUBSCRIPTION_PLAN.PHOTO}
						);
					}
				} else {
					plansToRender.push(DESKTOP_APPS.DESIGNER, DESKTOP_APPS.WEB, DESKTOP_APPS.PHOTO);
				}
			};

			const addAddonsToRenderQueue = () => {
				perpetualAddons.forEach(addon => {

					const addonData = getAddonDataForDownload(addon.id);
					addonData.owned = true;

					if (addon.paidQuantity > addon.usedQuantity || addon.users.includes(this.props.user.userId)) {
						let higherVersionAvailable = false;
						if (addonData.isPerpetual && addonData.productVersion === 19 &&
							!plansToRender.find(item => item.itemKey === `${addonData.productKey}-20`)) {
							// A V19 owner should see V19 and V20 downloads. A V20 owner should only see V20. 
							const addonDataV20 = getAddonDataForDownload(addon.id, 20);
							addonDataV20.owned = true;
							plansToRender.push({...addonDataV20, primary: true});
							higherVersionAvailable = true;
						}

						if (!plansToRender.find(item => item.itemKey === `${addonData.productKey}-${addonData.productVersion}`)) {
							plansToRender.push({...addonData, primary: !higherVersionAvailable});
							
						}						
					}
				});
			};

			if (!hasPerpetualPlan) {
				addSubscriptionsToRenderQueue();
			} else if (hasPerpetualPlan && !hasSubscription) {
				addAddonsToRenderQueue();
			} else if (hasPerpetualPlan && hasSubscription) {
				addSubscriptionsToRenderQueue();
				addAddonsToRenderQueue();
			}

			return (<Fragment>
				{this.renderProductGroup(plansToRender, true)}
				{this.renderProductGroup(plansToRender, false)}
			</Fragment>);
		}

		render() {
			const { classes } = this.props;
			return (
				<CenteredContent>
					<Header>
						{localize('download-header')}
					</Header>
					<Description>
						{localize('download-description1')}<br />
						{localize('download-description2')}
						<span className={classes.windowsInfo}>{localize('download-description3')}</span>
					</Description>
					{this.renderProducts()}
				</CenteredContent >
			);
		}

		renderProductGroup(plansToRender, renderOwned) {
			const { classes } = this.props;

			const result = plansToRender.map((plan, index) => {
				const { downloadUrl, storageKey, trackingKey, title, detailsUrl, owned, primary} = plan;

				const primaryOwned = owned && primary;

				if (renderOwned && !primaryOwned || !renderOwned && primaryOwned) {
					return;
				}

				return (
					<Grid container key={`product-item-${index+1}`} alignItems="center" className={classes.product}>
						<Button
							onClick={() => this.onDownloadClick(downloadUrl, storageKey, trackingKey)}
							variant={primaryOwned ? 'contained' : 'outlined'}
							data-tid="button-download"
							color='primary'
							size='large'
							title='Download'
							className={classNames(classes.button, primaryOwned ? classes.buttonOwned : classes.buttonNotOwned)}
						>
							{localize('download-download', title)}

						</Button>
						{detailsUrl && <Link
							href={detailsUrl}
							target="_blank"
							variant='body1'
							underline='always'
							className={classes.link}
						>{localize('download-find-out-more')}</Link>}
					</Grid>);
			});			

			if (result.some(item => Boolean(item))) {
				if (renderOwned) {
					return (<div className={classes.ownedProducts}>
						<Typography
							variant='body1'
							className={classes.ownedProductsTitle}
						>
							{localize('download-you-own-this-product')}
						</Typography>
						{result}
					</div>);

				} else {
					return (<div className={classes.otherProducts}>{result}</div>);
				}
			}
		}

}

XCPlus.propTypes = {
	classes: PropTypes.object,
	company: PropTypes.object,
	settings: PropTypes.object, // settings from session.user
	writeUserSettings: PropTypes.func, // action creator from session module
	user: PropTypes.object.isRequired,
	writeCompanySettings: PropTypes.func
};

// Leaving Redux bindings for phase 2 of P9052-13492.
const mapStateToProps = state => ({
	company: state.companies.rawDataById[state.companies.selectedId],
	settings: state.session.user.settings,
	user: state.session.user
});
const mapDispatchToProps = dispatch => bindActionCreators({
	writeUserSettings,
	writeCompanySettings
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(XCPlus);


// WEBPACK FOOTER //
// ./src/containers/XCPlus/XCPlus.js